var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 80",
    fill: "none",
    stroke: "#002333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 71.5L29.4 58C30 55.3 32.5 53.4 35.3 53.4H37.3C48.5 53.4 56.3 48.1 56.3 41.2C56.3 36.7 53.1 33.1 48.7 32.5C43.3 31.8 38.8 36 38.8 41.2C38.8 46.7 45 53.4 57.9 53.4H60.2C62.8 53.4 65.1 55.1 65.9 57.6L67.7 64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 27C34.4 26.3 35.6 25.8 36.9 25.8H38.7C49.2 25.8 56.3 20.7 55.8 14.2C55.5 10.6 52.6 7.50001 49 7.00001C44.1 6.30001 40 10.1 40 14.8C40 19.8 45.6 25.8 57.2 25.8H60C62.9 25.8 65.5 28.1 65.8 31L66.2 34.4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8 42.3C23 42.3 17.7 36 17.7 30.8C17.7 25.9 22 22 27.1 22.7C30.8 23.2 33.8 26.4 34.1 30.1C34.7 36.8 27.2 42.2 16.4 42.2C13.6 42.2 11.3 44.3 11.1 47L9.5 63.2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6 39.1C39.6 39.1 44.6 39.5 47.8 36.3C50.8 39.3 55.2 39.2 55.2 39.2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6 25C31.6 25 28.4 27.4 24.2 28.7C20 29.9 18.1 29.9 18.1 29.9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6 35.2H80.8V27.4C80.8 26.3 79.9 25.3 78.7 25.3H74.6C73.5 25.3 72.5 26.2 72.5 27.4V35.2H64.7C63.6 35.2 62.6 36.1 62.6 37.3V41.4C62.6 42.5 63.5 43.5 64.7 43.5H72.5V51.3C72.5 52.4 73.4 53.4 74.6 53.4H78.7C79.8 53.4 80.8 52.5 80.8 51.3V43.5H88.6C89.7 43.5 90.7 42.6 90.7 41.4V37.3C90.7 36.1 89.8 35.2 88.6 35.2Z",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 16.8L44.2 12.4C44.8 11.7 45.7 11.2 46.6 11.2H49.1C50 11.2 50.9 11.6 51.5 12.3L55.1 16.7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrow);
export default __webpack_public_path__ + "static/media/grow.be2931df324d754cb22bcf6b9b9897cf.svg";
export { ForwardRef as ReactComponent };